import styled from 'styled-components';

const Wrapper = styled.div``;

const Heading = styled.h2`
  font-size: 16px;
  line-height: 27px;
  color: #294f79;
  font-weight: 400;
  margin-bottom: 30px;

  @media (min-width: 768px) {
    font-size: 18px;
    line-height: 30px;
  }
`;

const Table = styled.table`
  text-align: left;
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 30px;

  th {
    font-weight: 600;
    padding: 7px;
  }

  tr:nth-child(even) {
    background: #f1f1f1;
  }

  td {
    vertical-align: top;
    padding: 7px;
  }

  td:first-of-type {
    white-space: nowrap;
  }

  a {
    color: #13b34f;
  }

  /* Mobile responsive table styles */
  @media (max-width: 600px) {
    /* Force table to not be like tables anymore */
    &,
    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    /* Hide table headers (but not display: none;, for accessibility) */
    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    td {
      /* Behave  like a "row" */
      border: none;
      position: relative;
      padding-left: 34%;
    }

    td:before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      top: 6px;
      left: 6px;
      width: 30%;
      padding-right: 10px;
      white-space: nowrap;
    }

    /*
    Label the data
    */
    td:nth-of-type(1):before {
      content: 'Date';
    }
    td:nth-of-type(2):before {
      content: 'City';
    }
    td:nth-of-type(3):before {
      content: 'Location';
    }
  }

  @media (min-width: 768px) {
    td,
    th {
      padding: 14px 16px;
    }
  }
`;

export { Wrapper, Heading, Table };
